import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import IRASService from "../../services/IRASService";

const initialState = {
    category: [],
    categoryMapping:[],
    status: 'idle',
}

export const fetchCategory = createAsyncThunk('category', async () => {
    const response = await IRASService.getCategory();
    return response;
});

export const fetchCategoryMapping = createAsyncThunk('category-mapping', async () => {
    const response = await IRASService.getCategoryMapping();
    return response;
});

export const IRASSettingsSlice = createSlice({
    name: "irasSettings",
    initialState,
    reducers:{},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategory.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchCategory.fulfilled, (state, action) => {
                state.status = "idle";
                state.category = action.payload;
            })
            .addCase(fetchCategoryMapping.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchCategoryMapping.fulfilled, (state, action) => {
                state.status = "idle";
                state.categoryMapping = action.payload;
            });
    }
})

export const selectCategory = (state) => {
    return state.irasSettings.category
}

export const selectCategoryMapping = (state) => {
    return state.irasSettings.categoryMapping
}

export default IRASSettingsSlice.reducer;